import * as R from 'ramda';
import React, { useEffect, useState } from 'react';
// helpers/constants
import * as GC from '../constants';
import * as G from '../helpers';
// utilities
import { sendRequest } from '../utilities/http';
import endpointsMap from '../utilities/endpoints';
//////////////////////////////////////////////////

const useAsyncAccessorials = (branchGuid, accessorialType) => {
  const [accessorialsConfigs, setAccessorialsConfigs] = useState(null);

  useEffect(() => {
    const getAccessorialsRequest = async () => {
      if (G.isNilOrEmpty(branchGuid)) return;

      const params = accessorialType
        ? { types: accessorialType, enterpriseGuid: branchGuid }
        : { [GC.FIELD_BRANCH_GUID]: branchGuid };
      const endpoint = accessorialType ? endpointsMap.accessorialsListByTypes : endpointsMap.accessorialsListEndpoint;

      const res = await sendRequest('get', endpoint, { params });

      const { data, status } = res;

      if (R.and(G.isResponseSuccess(status), G.isNotEmpty(data))) {
        setAccessorialsConfigs(data);
      } else {
        G.handleFailResponseSimple(
          res,
          false,
          'withAsyncAccessorials -> getAccessorialsRequest',
        );
      }
    };

    getAccessorialsRequest();
  }, [branchGuid, accessorialType]);

  return accessorialsConfigs;
};

export const withAsyncAccessorials = (Component) => (props) => {
  const { branchGuid, accessorialType } = props;

  const accessorialsConfigs = useAsyncAccessorials(branchGuid, accessorialType);

  return <Component {...props} accessorialsConfigs={accessorialsConfigs} />;
};
